export enum HASHTAGS {
  CASES = "cases",
  LIMITER = "limiter",
  COMPRESSOR = "compressor",
  DESSER = "desser",
  SATURATOR = "saturator",
  TRIPLE_SLOT = "triple slot",
  DUAL_SLOT = "dual slot",
  SINGLE_SLOT = "single slot",
  MULTIBAND_COMP = "multiband compressor",
  EQ = "eq",
  MASTERING = "mastering",
  LIVE_SOUND = "live sound",
  RECORDING = "recording",
  MIXING = "mixing",
  NEXT_GEN = "next generation",
  MICPRE = "mic pre",
  INTERFACES = "interface",
  ACCESSORIES = "accesories",
  RACK = "rack mounted",
  ONE_U = "1u",
  TWO_U = "2u",
  THREE_U = "3u",
  FOUR_U = "4u",
  FIVE_U = "5u",
  API_500 = "API 500 Series",
  VST = "vst",
  FX = "effects",
  SUMMING_MIXER = "summer",
  MICROPHONE = "microphone",
  DI = "DI",
  DISCONTINNUED = "Discontinued",
  SPEIA = "sepia",
}
